// Types
export interface Category {
  id: number;
  name: string;
}

interface CategoryState {
  loading: boolean;
  category_data: Category[];
  error: string | null;
}

const initialState: CategoryState = {
  loading: false,
  category_data: [],
  error: null,
};

type Action =
  | { type: 'CATEGORY_LOADING' }
  | { type: 'CATEGORY_SUCCESS'; payload: Category[] }
  | { type: 'CATEGORY_ERROR'; payload: string };

const CategoryReducer = (state = initialState, action: Action): CategoryState => {
  switch (action.type) {
    case 'CATEGORY_LOADING':
      return { ...state, loading: true };
    case 'CATEGORY_SUCCESS':
      return { loading: false, category_data: action.payload, error: null };
    case 'CATEGORY_ERROR':
      return { loading: false, category_data: [], error: action.payload };
    default:
      return state;
  }
};

export default CategoryReducer;
